import React from 'react';
import IconFromPath from '../IconFromPath/IconFromPath';
import Polygon from './Polygon';

const PolygonIcon = props => (
    <IconFromPath {...props} Path={Polygon} />
);

export default PolygonIcon;
